import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  user: any;
  onConfirm: () => void;
}

const DeleteUserModal: React.FC<Props> = ({
  isOpen,
  toggle,
  user,
  onConfirm
}) => {
  if (!user) return null;

  return (
  <Modal isOpen={isOpen} toggle={toggle} centered>
  <ModalBody className="text-center p-4">

    {/* Warning Icon */}
    <div
      style={{
        width: "70px",
        height: "70px",
        borderRadius: "50%",
        background: "#ffe5e5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 15px",
        fontSize: "30px",
        color: "#dc3545"
      }}
    >
      ⚠
    </div>

    {/* Title */}
    <h5 className="fw-bold mb-2">Delete User</h5>

    {/* Message */}
    <p className="text-muted mb-1">
      Are you sure you want to delete
    </p>

    <h6 className="fw-bold text-danger mb-3">
      {user.name}
    </h6>


    {/* Buttons */}
    <div className="d-flex justify-content-center gap-3 mt-4">
      <Button
        color="light"
        className="px-4 rounded-pill border"
        onClick={toggle}
      >
        Cancel
      </Button>

      <Button
        color="danger"
        className="px-4 rounded-pill"
        onClick={onConfirm}
      >
        Delete
      </Button>
    </div>

  </ModalBody>
</Modal>
  );
};

export default DeleteUserModal;